module.exports = __webpack_public_path__ + "media/public/images/slider/banner_desktop-2894e115da5658d286823abebe3fb718.png";